<video id="remote-cam-video-tag" [class.fullsize]="fullsized" playsinline autoplay></video>
